<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<!-- <van-field v-else>
		<template #input> -->
	<van-checkbox-group v-else v-model="value" :disabled="disabled" direction="horizontal">
		<van-checkbox v-for="item in params" :key="item.value" :name="item.value" shape="square">
			{{ item.label }}
		</van-checkbox>
	</van-checkbox-group>
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		params: {
			label: string;
			value: string;
			[key: string]: any;
		}[];
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	// 后端存的是字符串，需要调整为数组
	const value = computed({
		get() {
			return props.modelValue ? props.modelValue?.split(',') : [];
		},
		set(val) {
			emit('update:modelValue', val.join(','));
		},
	});
</script>

<style scoped>
	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
